import { ConnectionConfig } from '../components/ConnectionsPanels/types';

export interface IConnection {
  id?: string;
  sourceDeviceNumber: number;
  sourceDockNumber: string;
  targetAction: string;
  targetActionParameters: object;
  targetDeviceNumber: number;
  targetDockNumber: string;
  triggerEvent: string;
  triggerEventParameters: object;
}
export interface IDevicesConnection {
  connection: IConnection;
  connectionDirection: string;
  isInputConnection: object;
  isOutputConnection: object;
}

class DevicesConnection {
  private _connection: ConnectionConfig;

  constructor(connection: ConnectionConfig) {
    this._connection = connection;
  }

  public get connection() {
    return this._connection;
  }

  public set connection(connection) {
    this._connection = connection;
  }

  public isConnectionValid({
    sourceDeviceNumber,
    sourceDockNumber,
    targetAction,
    targetDeviceNumber,
    targetDockNumber,
    triggerEvent
  }): boolean {
    if (
      Number.isInteger(sourceDeviceNumber) &&
      sourceDeviceNumber !== this._connection.sourceDeviceNumber
    ) {
      return false;
    }

    if (
      sourceDockNumber &&
      sourceDockNumber !== this._connection.sourceDockNumber
    ) {
      return false;
    }

    if (targetAction && targetAction !== this._connection.targetAction) {
      return false;
    }

    if (
      Number.isInteger(targetDeviceNumber) &&
      targetDeviceNumber !== this._connection.targetDeviceNumber
    ) {
      return false;
    }

    if (
      targetDockNumber &&
      targetDockNumber !== this._connection.targetDockNumber
    ) {
      return false;
    }

    if (triggerEvent && triggerEvent !== this._connection.triggerEvent) {
      return false;
    }

    return true;
  }
}

export default DevicesConnection;
